"use client";
import { useState, useEffect, useRef, useMemo } from "react";
import { BuyOrAddToCarWrapper, CounterBoxWrapper } from "@/styles/product";
import Counter from "../../components/counter/index";
import UKToast from "@/components/UKToast";
import { getUserUUIDFromCookie } from "@/utils/userUtils";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { styled as muiStyled } from "@mui/material/styles";
import { AddCart } from "@/apis/service";

import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25217";
import { dataExpTagConfig } from "@/components/product/const";
import { useTranslation } from "@/i18n/client";
import { useRouter } from "next/navigation";
import OutOfStackController from "@/utils/outofStock/outofStockController";
import { takeCouponReq } from "@/apis/service";
import ChooseDelivery from "./chooseDelivery";
import { gtagAddCartLog } from "@/utils/thirdParty/gtag";
import { 
  callAfterLoginByUrl, 
  LoginCallBackType 
} from "@/lib/jdiClientUtils";
import cookieUtil from "@/utils/cookieUtils";
const buttonCommonStyle = {
  fontSize: "16px",
  width: "228px",
  height: "48px",
  borderRadius: "4px",
  lineHeight: "48px",
  textAlign: "center",
  fontWeight: 700,
};
const AddCartButton = muiStyled(Button)(({ theme, width }) => ({
  ...buttonCommonStyle,
  width: width || "228px",
  border: "1.5px solid #505259",
  backgroundColor: "#FFFFFF",
  color: "#1A1A1A",
  "&:hover": {
    color: "#990915",
    borderColor: "#990915",
    backgroundColor: "#FFFFFF",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    opacity: 0.5,
    cursor: "no-drop",
    color: "#C2C4CC",
    borderColor: "#C2C4CC",
    backgroundColor: "transparent",
  },
}));

const BuyNowButton = muiStyled(Button)(({ theme }) => ({
  ...buttonCommonStyle,
  color: "#fff",
  backgroundColor: "#CC0C1C",
  "&:hover": {
    borderColor: "#990915",
    backgroundColor: "#990915",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    opacity: 0.5,
    cursor: "no-drop",
    color: "#fff",
    borderColor: "#FF9FA7",
    backgroundColor: "#FF9FA7",
  },
}));

const formatBottomBarData = (data: any) => {
  const { buttons, unsupportedPurchaseInfo } = data || {};
  const buyProductType = unsupportedPurchaseInfo?.type || 1;
  const btns = buttons?.primaryBtns?.find((item: any) => item?.btnId === "btn_notify");
  return {
    buyProductType,
    isNeedToNotify: !!btns,
    notifyBtn: buttons?.primaryBtns?.[0]
  }
}
export default function BuyOrAddToCar(props: any) {
  const floors = props.floors;
  const autoClaimCoupon = props.autoClaimCoupon;
  const currency = props.currency;

  const { t } = useTranslation();
  const router = useRouter();
  const { productCommonFloor, productBottomBarFloor } = floors;
  const data = productCommonFloor?.data;
  const Basic_data = data?.["C-M#viewCommonItem&commonBasic"];

  const product_data = data?.["C-M#viewCommonItem&commonCore"];

  const deliveryInfo_data = data?.deliveryInfo
  const { mainTitle, fulfillmentMethodList } = deliveryInfo_data
  const isMoreDelivery = fulfillmentMethodList && fulfillmentMethodList?.length > 1
  const [productNumber, setproductNumber] = useState<number>(1);
  const [openDialog, setOpenDialog] = useState(false); //是否开启配送弹窗
  const [shipmentType, setShipmentType] = useState(() => {
    let defaultType
    if(fulfillmentMethodList && fulfillmentMethodList?.length > 1) {
      defaultType = fulfillmentMethodList?.find((item: any) => item.selectedStatus)?.shipmentType;
    }else if(fulfillmentMethodList?.length === 1){
      defaultType = fulfillmentMethodList[0]?.shipmentType
    }
    return defaultType || "66";
  });
  
  // const [floatHeight, setFloatHeight] = useState<number>();
  const stockValue = Basic_data?.maximumPurchaseLimit || 200;
  const { isNeedToNotify, buyProductType, notifyBtn } = formatBottomBarData(productBottomBarFloor?.data);
  const cartuuidRef = useRef<string>("");
  const buyRef = useRef<string>();
  const onNotify = () => {
    OutOfStackController.getInstance().openOutOfStockDialog([product_data.skuId], () => {
      router.refresh();
    });
  }
  const addCart = async (props: any) => {
    const params = {
      cartuuid: cartuuidRef.current,
      num: productNumber,
      skuId: product_data.skuId,
    };

    const data = await AddCart(params);
    if (data?.code === "200") {
      gtagAddCartLog([product_data.skuId]);
      UKToast.show({
        content: t("dp.successCart"), // 弹窗内容
        icon: "success", // 可选：success, fail, loading, warn, info，影响图标
      });
      window?.JDIheader?.initCartNum();
    } else {
      UKToast.show({
        content: t("dp.failCart"), // 弹窗内容
        icon: "error", // 可选：success, fail, loading, warn, info，影响图标
      });
    }

    sendClickTrack.Productdetail_Addtocart({
      mainskuid: product_data.skuId,
      skuNum: String(productNumber),
    });
  };
  
  const handleClickBuyNow = () => {
    //如果有多个配送方式，则打开选择，否则直接结算
    if (isMoreDelivery) {
      setOpenDialog(true);
    } else {
      openCheckout()
    }

  }
  const onBuyNowReq = async ({
    addCartParams,
    autoClaimCouponParams
  }: any) => {
    const skuId = product_data.skuId
    const data = await AddCart({ refer: 7, ...addCartParams });
    if (data?.code === "200") {
      gtagAddCartLog([product_data.skuId]);
      if(autoClaimCoupon?.enable && autoClaimCouponParams) {
        // 自动领券
        const res = await takeCouponReq(autoClaimCouponParams);
        if(res.code === "200") {
          if(res?.msg) {
            res?.msg && UKToast.show({
              icon: "success", 
              duration: 10000,
              content: res?.msg,
            });
          }
        } 
      }
      let url =
        process.env.NODE_ENV === "development"
          ? `${process.env.NEXT_PUBLIC_FE_TEST_DOMAIN}/checkout`
          : `/checkout`;

      const searchUrl = `?ref=${skuId}&immediatelyBuy=true&shipmentType=${shipmentType}`
      window.location.href = url + searchUrl;
    } else {
      UKToast.show({
        content: t("common.pageStatus.serverError"),
        icon: "error",
      });
    }
  }
  // 打开结算页
  const openCheckout = async () => {
    let autoClaimCouponParams = null
    const skuId = product_data.skuId;
    try {
      sendClickTrack.Productdetail_GotoBuyNow({
        mainskuid: product_data.skuId,
        skuNum: String(productNumber),
      });
    } catch (err) {}
    const addCartParams = {
      cartuuid: cartuuidRef.current,
      num: productNumber,
      skuId,
    };
    if(autoClaimCoupon?.enable) {
      // 自动领券
      const takeCouponReqList = autoClaimCoupon?.couponList?.map((item: {
        ruleId: string,
        encryptedKey: string
      })=> ({
        ruleId: item?.ruleId,
        encryptedKey: item?.encryptedKey,
      }));
      if(takeCouponReqList?.length) {
        autoClaimCouponParams = {
          scenario: 1,
          takeCouponReqList
        }
      }
    }
    const availableParams = { addCartParams, autoClaimCouponParams }
    // 缓存BuyNow 接口参数

    cookieUtil.setSessionStorage("LoginCallBackType.dpBuyNow", availableParams)
    callAfterLoginByUrl(async ()=> onBuyNowReq(availableParams),
      {
        type: LoginCallBackType.dpBuyNow,
      },
    );
  };
  const handleChangeNum = (item: any, num: number) => {
    if (!item) {
      return;
    }
    setproductNumber(num);
  };
  //选择配送方式
  const handleSelectedDelivery = (value: string) => {
    setShipmentType(value);
  }
  const handleCallBackUrl = async ()=> {
    const url = new URL(window.location.href);
    const isNext = url.searchParams.get("isNext");
    const callbackOptType = url.searchParams.get("callbackOptType");
    if(isNext) {
      if(callbackOptType === LoginCallBackType.dpBuyNow) {
        url.searchParams.delete("callbackOptType");
        url.searchParams.delete("isNext");
        // 更新url, 不会刷新页面
        // window.history.pushState({}, '', url);
        // 用当前URL替换当前历史记录条目（不会创建新记录）
        
        const reqParamsStr = cookieUtil.getSessionStorage('LoginCallBackType.dpBuyNow')
        if(reqParamsStr) {
          try {
            const params = JSON.parse(reqParamsStr)
            await onBuyNowReq(params)
            window.history.replaceState(null, '', url.pathname + url.search);
          } catch(err) {}
        }
      }   
    }
  }

  useEffect(() => {
    cartuuidRef.current = getUserUUIDFromCookie();
    handleCallBackUrl()
  }, []);

  return (
    <>
      <CounterBoxWrapper>
        {/* 商品数量 */}
        <span className="counnter-title">{t("dp.qty")}</span>
        <Counter
          immediately={false}
          value={productNumber}
          minAmount={Basic_data?.minimumPurchaseLimit ? Number(Basic_data.minimumPurchaseLimit) : 1}
          maxAmount={Basic_data?.maximumPurchaseLimit ? Number(Basic_data.maximumPurchaseLimit) : 200}
          stock={stockValue}
          onChange={(num) => {
            if (num >= 1) {
              handleChangeNum(data, num);
            }
          }}
        />
      </CounterBoxWrapper>
      <BuyOrAddToCarWrapper ref={buyRef}>
        {/* 无购物车 */}

        <div className="inner sticky">
          {/* 无货状态判断值-2通知提醒 */}
          {buyProductType === -2 ?
            <Stack direction="column">
              <AddCartButton
                size="large"
                width="464px"
                disabled={!isNeedToNotify}
                onClick={() => { isNeedToNotify && onNotify() }}
              >{notifyBtn?.btnName}</AddCartButton>

            </Stack> :
            <Stack direction="row" spacing="8px">
              <AddCartButton
                size="large"
                disabled={buyProductType < 0}
                onClick={() => addCart(t)}
                exptag={"exp|" + EXPOSURE_RECORD.Productdetail_Addtocart_Expo}
                data-exptag-config={dataExpTagConfig}
              >
                {t("dp.addToCart")}
              </AddCartButton>
              <BuyNowButton
                size="large"
                disabled={buyProductType < 0}
                onClick={handleClickBuyNow}
                exptag={"exp|" + EXPOSURE_RECORD.Productdetail_GotoBuyNow_Expo}
                data-exptag-config={dataExpTagConfig}
              >
                {t("dp.buyNow")}
              </BuyNowButton>
            </Stack>
          }

        </div>
      </BuyOrAddToCarWrapper>

      {/* 点击buynow弹出选择配送方式的弹窗 */}
      <ChooseDelivery 
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        mainTitle={mainTitle}
        fulfillmentMethodList={fulfillmentMethodList}
        shipmentType={shipmentType}
        handleSelectedDelivery={handleSelectedDelivery}
        openCheckout={openCheckout}
      />
    </>
  );
}
